var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 90,
    viewBox: "0 0 115 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 65.6994L54.3998 25.3604C54.9356 24.8799 55.7473 24.8799 56.2833 25.3604L70.1876 45.2454V35.3422C70.1876 34.5631 70.8194 33.9315 71.5984 33.9315H80.9997C81.7788 33.9315 82.4105 34.5631 82.4105 35.3422V56.2046L93 65.6994",
    stroke: "#FF0000",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallFace);
export default __webpack_public_path__ + "static/media/smallFace.e62bb84f468be3dbf788809be4bbffcd.svg";
export { ForwardRef as ReactComponent };